import { Form, Nav } from "react-bootstrap";
import {
  HashRouter as Router,
  Routes,
  Route,
  NavLink,
  Navigate
} from "react-router-dom";
import StartPage from "../../pages/StartPage/StartPage.tsx";
import FAQPage from "../../pages/FAQPage/FAQPage.tsx";
import CreateMatterPage from "../../pages/CreateMatterPage/CreateMatterPage.tsx";
import ImportPage from "../../pages/ImportPage/ImportPage.tsx";
import { FaMagnifyingGlass, FaDownload, FaPenToSquare } from "react-icons/fa6";
import "./PageContainer.css";
import { useAppDispatch, useAppSelector } from "@/hooks/storeHooks.ts";
import { setIsLoggedInAction } from "@/actions/generalActions.ts";
import { getInitialDataAction } from "@/actions/importActions.ts";
import { FrameComponent } from "fmv-component-ui-library";
import { FrameColor } from "@/utils/enums.ts";
import { BsPersonLinesFill } from "react-icons/bs";
import MyMatters from "@/pages/MyMatters/MyMatters.tsx";

const PageContainer = () => {
  const dispatch = useAppDispatch();
  const isLoggedIn = useAppSelector(state => state.application.isLoggedIn);
  const currentUser = useAppSelector(state => state.application.currentUser);

  const handleSwitchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.checked) {
      dispatch(setIsLoggedInAction(false));
      dispatch(getInitialDataAction());
    } else {
      dispatch(setIsLoggedInAction(true));
      dispatch(getInitialDataAction());
    }
  };

  return (
    <Router>
      <div className="primary primary page-container">
        <FrameComponent
          color={FrameColor.BLUE}
          headerAlign="left"
          header={
            <div className="d-flex justify-content-between">
              <div>FAQ och Självbetjäning Kundtjänst</div>
              <div>Version 2.0</div>
            </div>
          }
        >
          <div className="navbar">
            <Nav variant="pills" className="mb-3" defaultActiveKey="/">
              <Nav.Item>
                <Nav.Link as={NavLink} to="/">
                  Start
                </Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link as={NavLink} to="/FAQs">
                  <FaMagnifyingGlass />
                  FAQs
                </Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link as={NavLink} to="/skapa-arende">
                  <FaPenToSquare />
                  Skapa ärende
                </Nav.Link>
              </Nav.Item>
              {!isLoggedIn && currentUser?.IsSiteAdmin && (
                <Nav.Item>
                  <Nav.Link as={NavLink} to="/import">
                    <span>
                      <FaDownload />
                    </span>
                    Import
                  </Nav.Link>
                </Nav.Item>
              )}
              {isLoggedIn && currentUser?.Id !== -1 && (
                <Nav.Item>
                  <Nav.Link as={NavLink} to="/mina-arenden">
                    <span>
                      <BsPersonLinesFill size={19} />
                    </span>
                    Mina ärenden
                  </Nav.Link>
                </Nav.Item>
              )}
            </Nav>
            {window.location.hostname.includes("localhost") && (
              <Form>
                <Form.Check
                  type="switch"
                  id="custom-switch"
                  label={isLoggedIn ? "Logp" : "Logistikportalen"}
                  checked={!isLoggedIn}
                  onChange={e => handleSwitchChange(e)}
                />
              </Form>
            )}
          </div>
          {/* Page Content */}
          <Routes>
            <Route path="/" element={<StartPage />} />
            <Route path="/FAQs" element={<FAQPage />} />
            <Route path="/skapa-arende" element={<CreateMatterPage />} />
            {!isLoggedIn && currentUser?.IsSiteAdmin && (
              <Route
                path="/import"
                element={
                  !isLoggedIn && currentUser?.IsSiteAdmin ? (
                    <ImportPage />
                  ) : (
                    <Navigate to="/" replace />
                  )
                }
              />
            )}
            {isLoggedIn && currentUser?.Id !== -1 && (
              <Route
                path="/mina-arenden"
                element={
                  isLoggedIn && currentUser?.Id !== -1 ? (
                    <MyMatters />
                  ) : (
                    <Navigate to="/" replace />
                  )
                }
              />
            )}
          </Routes>
        </FrameComponent>
      </div>
    </Router>
  );
};

export default PageContainer;
